import React from 'react';

const ColorBox = (props) => (
    <div className={props.class} />
)

export default ColorBox;